export enum SaveAs {
    Template = 'template',
    DesignTemplate = 'design-template'
}
